<template>
  <div id="app">
    <router-view/>
    <FactoryStaffConfirmModal/>
  </div>
</template>

<script>
import FactoryStaffConfirmModal from '@/components/FactoryStaffConfirmModal.vue';

export default {
  components: {
    FactoryStaffConfirmModal,
  },
};
</script>
